import React from "react"
// import { Link } from "gatsby"
import {RichText} from 'prismic-reactjs'

import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from "styled-components"




const ProjectsStyle = styled.div`
  .title{
    border-bottom: 4px solid #f6b93b;
    display: inline-block;
  }
  .projects{
    display: flex;
    text-align: left;
    /* width: 00px; */
    justify-content: space-around;
    /* flex-wrap: wrap; */
    /* align-items: center; */
    a{
      text-decoration: none;
      color: black;
      border-bottom: 2px solid #f6b93b;
      display: inline-block;
    }
    img{
      max-width: 300px;
      /* margin: 0 auto; */
    }
    display: grid;
    grid-template-columns: 1fr 1fr 1fr ;
   @media(max-width: 800px){
     display: flex;
      flex-direction: column;
      justify-content: center;
      img{
        max-width: 100%;
      }
      .single-project{
        margin-bottom: 20px;
      }
    }
  .description{
    font-size: .8em;
    /* color: red; */
  }
  .single-project{

    padding: 0 10px;
  }
  }



`



export const query =  graphql`{
  prismic {
    allProjectss(sortBy: meta_firstPublicationDate_DESC) {
      edges {
        node {
          project_name
          project_image
          description
          links_to_site_web {
            ... on PRISMIC__ExternalLink {
              url
            }
          }
          _meta {
            id
          }
        }
      }
    }
  }
}

`


const SecondPage = ({data}) => {

  const doc = data.prismic.allProjectss.edges;
  if(!doc) return null;
 return (
  <Layout>
    <SEO title="Projects" />
      <ProjectsStyle>
          <h2 className="title">Projects</h2>
                <div className="projects">
                {
                  doc.map(edge =>
                            (
                              <div className="single-project" key={edge.node._meta.id}>
                                  <img src={edge.node.project_image.url} alt=""/>
                                  <h3>{RichText.asText(edge.node.project_name)}</h3>
                                  <p className="description">{RichText.asText(edge.node.description)}</p>
                                  <a href={edge.node.links_to_site_web.url}>Link of website</a>
                              </div>
                            )
                          )
                }
                </div>
      </ProjectsStyle>
  </Layout>
  )
 }

export default SecondPage
